__webpack_require__.p = "https://cdn-challenge.mathletics.com/app/288/";